import { Injectable,Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { catchError,map } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import * as globalConstant from './../global_constant';
import { isPlatformBrowser } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class TicketEvaluation {
  isBrowser:boolean;
  apiDomain	   	    	=	globalConstant.DOMAIN;
  siteRequestFrom		=	globalConstant.SITE_REQUEST_FROM;
  ticketEventsApi		=	globalConstant.TICKET_EVENTS;
  ticketEventsDetailApi	=	globalConstant.TICKET_EVENT_DETAIL;
  ticketEventsGroupsApi	=	globalConstant.TICKET_EVENT_GROUPS;
  ourTicketApi			=	globalConstant.OUR_TICKETS_API;
  printEticketApi			=	globalConstant.PRINT_ETICKETS_API;
  priceStatsApi			=	globalConstant.EVENT_PRICE_STATS_API;
  eventTaxApi = globalConstant.GET_EVENTS_TAX;


  constructor(public router: Router,private http: HttpClient,@Inject(PLATFORM_ID) platformId: Object) {  
    this.isBrowser = isPlatformBrowser(platformId);

  } 
	
  ticket_event(formData,headers){
    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization':'Bearer '+headers,
          'requestFrom':this.siteRequestFrom,
        })
      };
      return this.http.post<any>(this.apiDomain+this.ticketEventsApi,formData,httpOptions).pipe(map(res=>{
        return res;
      }),
      catchError(err => {
        if(err.status == 401)
        {
          if(this.isBrowser){

            if(typeof localStorage !== 'undefined'){
              localStorage.removeItem('authUser')
              localStorage.removeItem('login_token')
              localStorage.removeItem('profile_img_url')
            }
            if (typeof window !== 'undefined') {
              window.location.href = '/login'
            }
          }
        }
        return err.error;
      }));
  }
  ticket_event_detail(formData,headers){
    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization':'Bearer '+headers,
          'requestFrom':this.siteRequestFrom,
        })
      };
      return this.http.post<any>(this.apiDomain+this.ticketEventsDetailApi,formData,httpOptions).pipe(map(res=>{
        return res;
      }),
      catchError(err => {
        if(err.status == 401)
        {
          if(this.isBrowser){

            if(typeof localStorage !== 'undefined'){
              localStorage.removeItem('authUser')
              localStorage.removeItem('login_token')
              localStorage.removeItem('profile_img_url')
            }
            if (typeof window !== 'undefined') {
              window.location.href = '/login'
            }
          }
        }
        return err.error;
      }));
  }
  ticket_event_group(formData,headers){
    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization':'Bearer '+headers,
          'requestFrom':this.siteRequestFrom,
        })
      };
      return this.http.post<any>(this.apiDomain+this.ticketEventsGroupsApi,formData,httpOptions).pipe(map(res=>{
        return res;
      }),
      catchError(err => {
        if(err.status == 401)
        {
          if(this.isBrowser){

            if(typeof localStorage !== 'undefined'){
              localStorage.removeItem('authUser')
              localStorage.removeItem('login_token')
              localStorage.removeItem('profile_img_url')
            }
            if (typeof window !== 'undefined') {
              window.location.href = '/login'
            }
          }
        }
        return err.error;
      }));
  } 
  our_ticket(headers){
    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization':'Bearer '+headers,
          'requestFrom':this.siteRequestFrom,
        })
      };
      return this.http.post<any>(this.apiDomain+this.ourTicketApi,'',httpOptions).pipe(map(res=>{
        return res;
      }),
      catchError(err => {
        if(err.status == 401)
        {
          if(this.isBrowser){

            if(typeof localStorage !== 'undefined'){
              localStorage.removeItem('authUser')
              localStorage.removeItem('login_token')
              localStorage.removeItem('profile_img_url')
            }
            if (typeof window !== 'undefined') {
              window.location.href = '/login'
            }
          }
        }
        return err.error;
      }));
  }
  ticket_download(data,headers){
    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization':'Bearer '+headers,
          'requestFrom':this.siteRequestFrom,
        })
      };
      return this.http.post<any>(this.apiDomain+this.printEticketApi,data,httpOptions).pipe(map(res=>{
        return res;
      }),
      catchError(err => {
        if(err.status == 401)
        {
          if(this.isBrowser){

            if(typeof localStorage !== 'undefined'){
              localStorage.removeItem('authUser')
              localStorage.removeItem('login_token')
              localStorage.removeItem('profile_img_url')
            }
            if (typeof window !== 'undefined') {
              window.location.href = '/login'
            }
          }
        }
        return err.error;
      }));
  }
  
  getEventsPriceData(data, headers){
    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization':'Bearer '+headers,
          'requestFrom':this.siteRequestFrom,
        })
      };
      return this.http.post<any>(this.apiDomain+this.priceStatsApi,data,httpOptions).pipe(map(res=>{
        return res;
      }),
      catchError(err => {
        if(err.status == 401)
        {
          if(this.isBrowser){

            localStorage.removeItem('authUser')
            localStorage.removeItem('login_token')
            localStorage.removeItem('profile_img_url')
            window.location.href = '/login'
          }
        }
        return err.error;
      }));
  }

  getEventsTaxData(data, headers){
    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization':'Bearer '+headers,
          'requestFrom':this.siteRequestFrom,
        })
      };
      return this.http.post<any>(this.apiDomain+this.eventTaxApi,data,httpOptions).pipe(map(res=>{
        return res;
      }),
      catchError(err => {
        if(err.status == 401)
        {
          if(this.isBrowser){

            localStorage.removeItem('authUser')
            localStorage.removeItem('login_token')
            localStorage.removeItem('profile_img_url')
            window.location.href = '/login'
          }
        }
        return err.error;
      }));
  }
}




